/* eslint-disable import/order */
/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import {
    scheduleService
} from '../../../../../../../service';
import
ScheduledMeetingListItem
from '../ScheduledMeetingListItem';
import ScheduledMeetingView from '../ScheduledMeetingView';


const ScheduledMeetingList = props => {

    const [ sheduledMeetings, setSheduledMeetings ] = useState([]);
    const [ showMeetingDetail, setShowMeetingDetail ] = useState(false);
    const [ selectedMeeting, setSelectedMeeting ] = useState({});

    const { onEditMeeting, user } = props;

    useEffect(() => {
        (async () => {
            try {
                const scheduledMeetings = await scheduleService.getMyMeetings();

                setSheduledMeetings(scheduledMeetings);
            } catch (e) {
                // Some fetch error
            }
        })();

    }, []);
    const deleteSchuleMeeting = useCallback(sheduledMeetingItem => {
        (async () => {
            try {
                const deletedMeeting = await scheduleService.deleteMeetingSchedule(sheduledMeetingItem._id);

                if (deletedMeeting) {
                    const filterSheduledMeeting = sheduledMeetings.filter(meet => meet._id !== deletedMeeting.id) || [];

                    setSheduledMeetings(filterSheduledMeeting);
                }
            } catch (e) {
                // Some fetch error
            }
        })();

    }, [ sheduledMeetings ]);

    return (
        <div className='o-sched-call-meeting-content'>
            <div className="o-sched-call-meeting-content-title">
                <h3>Schedule:</h3>
            </div>
            <div className='o-sched-call-meeting-content-list'>
                {sheduledMeetings.length === 0 && (
                    <div className='o-sched-call-meeting-content-list-empty'>
                        <p>No scheduled meetings</p>
                    </div>
                )}
            {
                sheduledMeetings?.map((sheduledMeetingItem, index) => (
                    <ScheduledMeetingListItem
                        key = { sheduledMeetingItem._id }
                        sheduledMeetingItem = { sheduledMeetingItem }
                        setShowMeetingDetail = { setShowMeetingDetail }
                        setSelectedMeeting = { setSelectedMeeting }
                        deleteSchuleMeeting = { deleteSchuleMeeting }
                        user = { user }
                        onEditMeeting = { onEditMeeting }
                        order={index === sheduledMeetings.length - 1}
                    />
            ))}
            </div>
            {showMeetingDetail && <ScheduledMeetingView
                selectedMeeting = { selectedMeeting }
                setShowMeetingDetail = { setShowMeetingDetail } />}
        </div>
    );

};

ScheduledMeetingList.propTypes = {
    onEditMeeting: PropTypes.func,
    user: PropTypes.shape()
};

export default ScheduledMeetingList;
